import "./registeremailsent.scss";
import { Link } from "react-router-dom";

interface RegistrationData {
  email: string;
}

const RegisterEmailSent = () => {
  const registrationData: RegistrationData | null = (() => {
    try {
      const stored = localStorage.getItem("registrationData");
      return stored ? JSON.parse(stored) : null;
    } catch {
      return null;
    }
  })();

  const email = registrationData?.email ?? "STUDENT'S EMAIL";

  return (
    <div className="registerEmailSentPage">
      <div className="headline">
        <h1>Thank You For Registering and Paying</h1>
      </div>
      <p>
        An email has been sent to the <strong>{email}</strong> with a
        confirmation link. Please click that link to confirm the{" "}
        <strong>{email}</strong> address.
      </p>
      <p>
        If you've already confirmed and are only paying, please{" "}
        <Link to="/login">login again</Link> to take your exam.
      </p>
    </div>
  );
};

export default RegisterEmailSent;
